<template>
  <ThemeProvider :theme="currentTheme">
    <RouterInjector :router="router" :routes="routes">
      <App />
    </RouterInjector>
  </ThemeProvider>
</template>

<script setup lang="ts">
// import { hublot } from '@hublot-io/core-ui/theme/theme-provider'
import {useAttributBeteStore,
        useDecoupeStore,
        useRegroupementPieceStore,
        useRendementPriceStore} from '@hublot-io/boucherie-core-store'
import {setCurrentContext} from '@hublot-io/core-data/api'
import {useConstants} from '@hublot-io/core-store/core/constants'
import {useFacture} from '@hublot-io/core-store/gestion/facture'
import {useFournisseurs} from '@hublot-io/core-store/gestion/fournisseurs'
import {useObjectif} from '@hublot-io/core-store/gestion/Objectif'
import {useStock} from '@hublot-io/core-store/gestion/stock'
import {useTypeFacture} from '@hublot-io/core-store/gestion/typeFacture'
import {useEventCalendar} from '@hublot-io/core-store/settings/eventsCalendar'
import {carnot, hublot} from '@hublot-io/core-ui/theme/theme-provider'
import ThemeProvider from '@hublot-io/core-ui/theme/theme.vue'
import RouterInjector from '@hublot-io/core-ui/utils/router-injector.vue'
import {routerKey, storeKey} from '@hublot-io/core-utils/utils/hooks'
import KeyboardService from '@hublot-io/poissonnerie-core-data/services/keyboard/KeyboardService'
import {useIntegrationStore} from '@hublot-io/poissonnerie-core-store/integration/integration'
import {useKeyboardStore} from '@hublot-io/poissonnerie-core-store/keyboard/keyboard'
import moment from 'moment'
import Vue, {computed, getCurrentInstance, provide, watch} from 'vue'

import App from './App.vue'
import routes from './router'
import config from './utils/apiUtils'


const contextStore = computed(() => getCurrentInstance().proxy.$store.state.context)
const currentTheme = computed(() => (contextStore.value.currentContext === 'poissonnerie' ? hublot : carnot))
const router = getCurrentInstance().proxy.$router
const pinia = getCurrentInstance().proxy.$pinia
const innerRouter = router

provide(routerKey, innerRouter)
provide(storeKey, pinia)

const constantsStore = useConstants()
const objectifStore = useObjectif()
const eventCalendarStore = useEventCalendar()
const typeFactureStore = useTypeFacture()
const factureStore = useFacture()
const fournisseurStore = useFournisseurs()
const stockStore = useStock()
const integrationStore = useIntegrationStore()
const keyboardStore = useKeyboardStore()
const decoupeStore = useDecoupeStore()
const attributBeteStore = useAttributBeteStore()
const regroupementPieceStore = useRegroupementPieceStore()
const rendementPriceStore = useRendementPriceStore()

document.addEventListener('deviceready', async () => {
  try {
  } catch (err) {
    console.error('[BOOT ERROR]', err)
  }
})

const history = moment().subtract(2, 'months').startOf('month').format('YYYY-MM-DD')

const authenticationClient = computed(() =>
  getCurrentInstance()?.proxy ? getCurrentInstance().proxy.$store.state.authentication.client : null
)

watch(
  () => authenticationClient.value,
  client => {
    if (client && client.serial) {
      integrationStore.setClient({serial: client.serial})
    }
  },
  {immediate: true, deep: true}
)

watch(
  () => contextStore.value,
  newContext => {
    //TODO refresh store data with reactivity d
    constantsStore.setConstants(config(newContext.currentContext))
    setCurrentContext(config(newContext.currentContext))
    objectifStore.loadObjectif()
    eventCalendarStore.loadEvents()
    typeFactureStore.loadTypesFacture()
    factureStore.loadAllFactures()
    factureStore.loadFactures(history)
    factureStore.loadAllFactures()
    fournisseurStore.loadFournisseurs()
    stockStore.loadStocks()
    decoupeStore.loadDecoupes()
    attributBeteStore.loadAll()
    regroupementPieceStore.loadRegroupementPieces()
    rendementPriceStore.loadLatestPrices()
    KeyboardService.getKeyboard().then(keyboard => keyboardStore.setKeyboard(keyboard))
  },
  {immediate: true, deep: true}
)
// @hublot-io/define-model
Vue.mixin({props: ['value']})
</script>

<style lang="scss"></style>
